import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f6a6670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "search_form" }
const _hoisted_6 = { class: "sns" }
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = { class: "search_input" }
const _hoisted_9 = { class: "search_keyword" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "search_type" }, "Keyword", -1))
const _hoisted_11 = { class: "search_btn" }
const _hoisted_12 = {
  key: 0,
  class: "modal_bg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sns.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass({ disabled: !item.isUsed })
                    }, [
                      _createElementVNode("img", {
                        src: item.status === 0 ? $setup.sns.imgUrl_gray[idx] : $setup.sns.imgUrl_color[idx],
                        onClick: ($event: any) => ($setup.selectSns(item))
                      }, null, 8, _hoisted_7)
                    ], 2))
                  }), 256))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.keyword) = $event)),
                    name: "searchKeyword",
                    class: "searchKeyword",
                    placeholder: "키워드를 입력하세요",
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchApi && $setup.searchApi(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, $setup.state.keyword]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchApi && $setup.searchApi(...args)))
                }, "검색")
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Spinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}